import React from 'react';
import { ArrowRight } from 'lucide-react';
import { SmartLink } from './shared';
import { useSite } from '../../hooks/useSiteConfig';

const DEFAULTS = { title: 'Still deciding?', text: 'Our team can help you compare fabrics, styles, privacy, light control and motorization options.', button_text: 'Book a Free Consultation', link: '/consultation' };

// Compact consultation prompt below the overview FAQs; wording is edited in Website Builder → Global elements.
export const ConsultationPrompt = () => {
  const { globals } = useSite();
  const p = { ...DEFAULTS, ...Object.fromEntries(Object.entries(globals?.consultation_prompt || {}).filter(([, v]) => v)) };
  return (
    <section className="bg-[color:var(--site-surface)] pb-20 lg:pb-28" data-testid="consultation-prompt">
      <div className="container-lg">
        <div className="border-t border-neutral-300 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-5">
          <div>
            <p className="font-serif text-2xl text-neutral-900" data-testid="consultation-prompt-title">{p.title}</p>
            <p className="mt-1 text-neutral-600 max-w-xl" data-testid="consultation-prompt-text">{p.text}</p>
          </div>
          <SmartLink to={p.link} data-cta={`${p.title} → ${p.button_text}`} className="group inline-flex flex-shrink-0 items-center gap-2 text-sm font-medium uppercase tracking-wide text-neutral-900 link-underline" data-testid="consultation-prompt-link">
            {p.button_text}<ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </SmartLink>
        </div>
      </div>
    </section>
  );
};
